/**
 * Defines a service for retrieving admin information for the current application.
 */
export class AdminService {
    static $inject = ['ConfigurationsService', 'MESSAGINGHUBDOMAIN'];
    constructor(ConfigurationsService, MESSAGINGHUBDOMAIN) {
        this.ConfigurationsService = ConfigurationsService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
    }
    async get(application, useConfigurationsApplication = false) {
        try {
            return await this.ConfigurationsService.get(`${application.shortName}@${this.MESSAGINGHUBDOMAIN}`, `${AdminService.ADMIN_IDENTITY_NAME}@${this.MESSAGINGHUBDOMAIN}`, useConfigurationsApplication);
        }
        catch (e) {
            return undefined;
        }
    }
}
AdminService.ADMIN_IDENTITY_NAME = 'admin';
AdminService.$inject = ['ConfigurationsService', 'MESSAGINGHUBDOMAIN'];
